import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useTheme} from "../header/Header";
import "../../css/utils.css";
import "../../css/silos/silos.css";
import { SearchOutlined } from '@ant-design/icons';

const getImage = (path) => {
    if (!path) return "";
    const clean = String(path).replace(/^\.?\//, "");
    return `/images/${clean}`;
}


export function GalleryList({images, backGround, imagesText=[]}){
    return (
        <div className={"galleryList"}>
            {images.map((image, i)=>{
                return (
                    <React.Fragment key={`galleryImage${i}`}>
                        <GalleryPhoto index={i} images={images} backGround={backGround} imagesText={imagesText}/>
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export function GalleryLinks({images, backGround, imagesLink, imagesText=[]}){
    return (
        <div className={"galleryList"}>
            {images.map((image, i)=>{
                return (
                    <React.Fragment key={`galleryImage${i}`}>
                        <GalleryLink index={i} images={images} backGround={backGround} imagesText={imagesText} imagesLink={imagesLink}/>
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export function GalleryPhoto({index, images, backGround, imagesText}) {

    const [mainImage, setMainImage] = useState(images[index]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(index);
    const {theme} = useTheme()

    const handleMainImageClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleNextImage = () => {
        const nextIndex = (currentIndex + 1) % images.length;
        setMainImage(images[nextIndex]);
        setCurrentIndex(nextIndex);
    };

    const handlePrevImage = () => {
        const prevIndex = (currentIndex - 1 + images.length) % images.length;
        setMainImage(images[prevIndex]);
        setCurrentIndex(prevIndex);
    };

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === "Escape") {
                setIsModalOpen(false);
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, []);


    return (
        <div className={`galleryPhoto ${theme} ${imagesText[index] ? "galleryBottomPadding" : ""}`}>
            {backGround.state && <div style={{ background: backGround.color }} className="galleryBackground" />}
            <div className="galleryZoom">
                <SearchOutlined />
            </div>
            <img
                className={backGround.state ? "imageWithBackground" : null}
                src={getImage(images[index])}
                alt="Основное изображение"
                onClick={handleMainImageClick}
            />
            {imagesText[index]? <p>{imagesText[index]}</p> :null}

            {isModalOpen && (
                <div className={"galleryZoomedPhoto"}>
                    <span className="close" onClick={handleCloseModal}>&times;</span>
                    <img
                        src={getImage(mainImage)}
                        alt={`Изображение ${currentIndex + 1}`}
                        className="photoService"
                    />
                    <button className="prev" onClick={handlePrevImage}> &#10094;</button>
                    <button className="next" onClick={handleNextImage}>&#10095;</button>
                </div>
            )}
        </div>
    );
}

export function GalleryLink({index, images, backGround, imagesText, imagesLink}) {

    return (
        <Link to={`/${imagesLink[index]}`} className={`galleryPhoto ${imagesText[index]? "galleryBottomPadding" : ""}`}>
            {backGround.state? <div style={{background: backGround.color}} className={"galleryBackground"}> </div> : null}
            <img
                className={backGround.state? "imageWithBackground": null}
                src={getImage(images[index])}
                alt="Основное изображение"
            />
            {imagesText[index]? <p>{imagesText[index]}</p> :null}
        </Link>
    );
}

export function StrongList({list,numbered = false}) {

    let width = list[0].title.length
    list.forEach(e => {
        if(e.title.length > width) {
            width = e.title.length
        }
    })

    return (
        <ul className={`strongList ${numbered? "listNumbered" : ""}`}>
            {list.map(e=>{
                return (
                    <li key={e.title}>
                        <span style={{minWidth: `${width + 3}ch`}}>
                            {e.title}
                        </span>
                        <span>{e.text}</span>
                    </li>
                )
            })}
        </ul>
    )

}

export function SingleList({list,numbered = false}) {

    let width = list[0].name.length
    list.forEach(e => {
        if(e.name.length > width) {
            width = e.name.length
        }
    })

    return (
        <ul className={`strongList ${numbered? "listNumbered" : ""}`}>
            {list.map(e=>{
                return (
                    <li key={e.name}>
                        <span style={{minWidth: `${width + 3}ch`}}>
                            {e.name}
                        </span>
                        <span>{e.value}</span>
                    </li>
                )
            })}
        </ul>
    )

}

export function DoubleList({list}) {

    list.forEach(e => {
        e.width = 0
        e.list.forEach(k=>{
            if(k.name.length > e.width) {
                e.width = k.name.length
            }
        })
    })

    return (
        <ul>
            {list.map(e=>{
                return (
                    <li key={e.title}>
                        <strong>{e.title}</strong>
                        <ul className={`strongList doubleList`}>
                            {e.list.map(k=>{
                                return (
                                    <li key={k.name}>
                                        <span style={{minWidth: `${e.width + 3}ch`}}>{k.name}</span>
                                        <span>{k.value}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </li>
                )
            })}
        </ul>
    )

}

export function NoStrongList({list, numbered = false}) {

    return (
        <ul className={`${numbered? "listNumbered" : ""}`}>
            {list.map(e=>{
                return (
                    <li key={`list${e}`}>{e}</li>
                )
            })}
        </ul>
    )

}

export function ProductListParams({params}){

    return (
        <div className={"product-listParams"}>

            {params.map(param=>{
                return (
                    <div key={param.name}>
                        <strong>{param.name}</strong>
                        <ul>
                            {param.list.map(e=>{
                                return <li key={e}>{e}</li>
                            })}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
}

export function TableConstructor({data}){

    const tableHead = {}
    const tableData = []


    data.header.forEach((e, i)=>{
        tableHead[`val${i+1}`] = e
    })

    if(data.type === "pTable") {
        data.data.forEach(e=>{
            const obj = {};
            obj.tableName = e.tableName
            obj.rows = []

            for (let i = 0; i < e.rows.length; i += data.header.length - 1) {
                const rows = {};

                // Для каждого элемента в текущей группе
                for (let j = 0; j < data.header.length - 1; j++) {
                    const index = i + j;
                    if (index < e.rows.length) {
                        rows[`val${j+1}`] = e.rows[index];
                    }
                }
                obj.rows.push(rows);
            }
            tableData.push(obj)
        })
    } else {
        for (let i = 0; i < data.data.length; i += data.header.length) {
            const obj = {};

            // Для каждого элемента в текущей группе
            for (let j = 0; j < data.header.length; j++) {
                const index = i + j;
                if (index < data.data.length) {
                    obj[`val${j+1}`] = data.data[index];
                }
            }
            tableData.push(obj);
        }
    }



    return (
        <>
            {data.type === "sTable"? <SilosTable tableData={tableData} tableHead={tableHead}/> : null}
            {data.type === "dTable"? <DescriptionTable tableData={tableData} tableHead={tableHead}/> : null}
            {data.type === "pTable"? <DescriptionTable tableData={tableData} tableHead={tableHead} className={"pneumaticSuspensionTable"}/> : null}
        </>
    )

}

export function SilosModelsConstructor({data}){

    const tableHead = {}
    const tableData = []


    data.header.forEach((e, i)=>{
        tableHead[`val${i+1}`] = e
    })

    for (let i = 0; i < data.data.length; i += data.header.length) {
        const obj = {};

        // Для каждого элемента в текущей группе
        for (let j = 0; j < data.header.length; j++) {
            const index = i + j;
            if (index < data.data.length) {
                obj[`val${j+1}`] = data.data[index];
            }
        }
        tableData.push(obj);
    }

    return (
        <SilosModelsBlock name={data.name} tableHead={tableHead} tableData={tableData}/>
    )

}

export function GalleryDescription({data}){

    const params = data.params? data.params : {
        state:true, color: "#ffffff"
    }

    return (
        <div className={"product-description-imageBlock"}>
            <GalleryList images={data.images.map(e=> e.image)} backGround={params} imagesText={data.images.map(e=> e.text)}/>
        </div>
    )
}

export function GalleryDescriptionLinks({data}){

    const params = data.params? data.params : {
        state:true, color: "#ffffff"
    }

    return (
        <div className={"product-description-imageBlock"}>
            <GalleryLinks images={data.images.map(e=> e.image)} backGround={params} imagesText={data.images.map(e=> e.text)} imagesLink={data.images.map(e=> e.link)}/>
        </div>
    )
}

export function PropertyList({list, theme="dark"}) {

    return (
        <ul className={`propertyList ${theme}`}>
            {list.map((e) => (
                <li key={e[0]} className={`list-item ${theme}`}>
                    <span className="item-title">{e[0]}</span>
                    <span className={`item-value ${theme}`}>{e[1]}</span>
                </li>
            ))}
        </ul>
    )

}

function SilosTable({tableHead, tableData}) {



    return (
        <div className={"silosBlock"}>
            <table className={`silosBlockTable`}>
                <thead>
                <tr>
                    {Object.keys(tableHead).map(key=>{
                        return (<th key={key}>{tableHead[key]}</th>)
                    })}
                </tr>
                </thead>
                <tbody>
                {tableData.map((td, i)=>{
                    return (
                        <tr key={`${td.val1}_${i}`}>
                            {Object.keys(tableHead).map(key=>{
                                return <td key={`${td.val1}_${i}_${key}`}>{td[key]}</td>
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}

function SilosModelsBlock({name, tableHead, tableData}){

    const [hidden, setHidden] = useState(true)

    return (
        <div className={"silosBlock"}>
            <div onClick={()=> setHidden(!hidden)}>
                <span>{hidden? "+" : "–"}</span>
                <span>{name}</span>
            </div>
            {hidden? null :
                <table className={`silosBlockTable ${hidden? "silosBlockTableHidden" : ""}`}>
                    <thead>
                    <tr>
                        {Object.keys(tableHead).map(key=>{
                            return (<th key={key}>{tableHead[key]}</th>)
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {tableData.map((td, i)=>{
                        return (
                            <tr key={`${td.val1}_${i}`}>
                                {Object.keys(tableHead).map(key=>{
                                    return <td key={`${td.val1}_${i}_${key}`}>{td[key]}</td>
                                })}
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            }
        </div>
    )
}

function DescriptionTable({tableHead, tableData, className=""}){

    let detailsPos = 1

    return (
        <table className={`detailedTable ${className}`}>
            <thead>
            <tr>
                {Object.keys(tableHead).map(key=>{
                    return (<th key={key}>{tableHead[key]}</th>)
                })}
            </tr>
            </thead>
            <tbody>
            {className === "pneumaticSuspensionTable"?
                tableData.map((e)=> {
                    return (
                        <React.Fragment key={e.tableName}>

                            {e.tableName === ""? null :
                                <tr key={`${e.tableName}_${detailsPos}`}>
                                    <td> </td>
                                    <td> </td>
                                    <td className={"pneumaticSuspensionTableName"}>{e.tableName}</td>
                                    <td> </td>
                                </tr>
                            }
                            {e.rows.map(row=>{
                                return (
                                    <tr key={`${row.val1}_${e.tableName}_${detailsPos}`}>
                                        <td>{detailsPos++}</td>
                                        {Object.keys(row).map((k,i)=>{
                                            return <td key={`${row.val1}_${i}`}>{row[k]}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </React.Fragment>
                    )
                })
                :
                tableData.map((td, i)=> {
                    return (
                        <tr key={`${td.val1}_${i}`}>
                            {Object.keys(tableHead).map(key=>{
                                return <td key={`${td.val1}_${i}_${key}`}>{td[key]}</td>
                            })}
                        </tr>
                    )
                })
            }
            </tbody>
        </table>
    )
}